export * from './partner'
export * from './contact-way'
export * from './faq'
export * from './news'
